import { render } from "./TakeDetails.vue?vue&type=template&id=ed6e89cc&scoped=true"
import script from "./TakeDetails.vue?vue&type=script&lang=js"
export * from "./TakeDetails.vue?vue&type=script&lang=js"

import "./TakeDetails.vue?vue&type=style&index=0&id=ed6e89cc&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-ed6e89cc"

export default script